import React from 'react'
import {createRoot} from 'react-dom/client';
import App from './App'

import Hls from 'hls.js'

const container = document.getElementById('app');
const root = createRoot(container);

window.Hls = Hls
root.render(<App/>);
